import styles from './FleetSalesImageMobile.module.scss';
import React from 'react';
import FleetSaleScrollFixedImages from './FleetSaleScrollFixedImages/FleetSaleScrollFixedImages';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

const image = [
  {
    id: 1,
    text: 'Photo 1',
    image: {
      url: '',
    },
  },
  {
    id: 2,
    text: 'Photo 1',
    image: {
      url: '',
    },
  },
  {
    id: 3,
    text: 'Photo 1',
    image: {
      url: '',
    },
  },
  {
    id: 4,
    text: 'Photo 1',
    image: {
      url: '',
    },
  },
];

const FleetSalesImageMobile = ({ fields }) => {
  return (
    <section className={styles.container}>
      <div className={styles.title} data-aos="fade-up">
        <h2 className={styles.titleText}>
          <RichText field={fields?.title} />
        </h2>
        <div className={styles.titleDescription}>
          <RichText field={fields?.subTitle} />
        </div>
      </div>

      <div className={styles.mobile}>
        <FleetSaleScrollFixedImages data={fields?.imgList} />
      </div>
    </section>
  );
};

export default FleetSalesImageMobile;
